/**
 * HULARA - Premium Leather Theme
 * Main JavaScript File
 * Shopify Online Store 2.0 Compliant
 */

(function() {
  'use strict';

  function agentLog(payload) {
    // #region agent log
    fetch('http://127.0.0.1:7863/ingest/a41c0059-bce1-4be7-8c7e-b3407a33c258',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'f20f57'},body:JSON.stringify(payload)}).catch(function(){});
    // #endregion
    try {
      // #region agent log
      navigator.sendBeacon('http://127.0.0.1:7863/ingest/a41c0059-bce1-4be7-8c7e-b3407a33c258', JSON.stringify(payload));
      // #endregion
    } catch (e) {}
  }

  // ===================================
  // Header Scroll + Compact / Hover Expand
  // ===================================
  function initHeader() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const compactMode = header.getAttribute('data-header-compact-mode') || 'always';
    let hoverOpen = false;
    let leaveTimer = null;

    function isDesktop() {
      return window.matchMedia('(min-width: 1025px)').matches;
    }

    function syncCompact() {
      if (!isDesktop()) {
        header.classList.remove('is-compact', 'is-expanded');
        document.documentElement.style.removeProperty('--header-height');
        return;
      }

      const shouldCompact =
        compactMode === 'always' ||
        (compactMode === 'scroll' && window.pageYOffset > 50);

      if (shouldCompact) {
        header.classList.add('is-compact');
        if (!hoverOpen) {
          header.classList.remove('is-expanded');
          document.documentElement.style.setProperty('--header-height', '56px');
        }
      } else {
        header.classList.remove('is-compact', 'is-expanded');
        document.documentElement.style.removeProperty('--header-height');
      }
    }

    function openExpanded() {
      if (!isDesktop() || !header.classList.contains('is-compact')) return;
      hoverOpen = true;
      if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
      }
      header.classList.add('is-expanded');
    }

    function scheduleClose() {
      if (leaveTimer) clearTimeout(leaveTimer);
      leaveTimer = setTimeout(function () {
        hoverOpen = false;
        header.classList.remove('is-expanded');
        leaveTimer = null;
      }, 160);
    }

    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      syncCompact();
    }, { passive: true });

    header.addEventListener('mouseenter', openExpanded);
    header.addEventListener('mouseleave', scheduleClose);
    header.addEventListener('focusin', openExpanded);
    header.addEventListener('focusout', function (e) {
      if (!header.contains(e.relatedTarget)) scheduleClose();
    });

    window.addEventListener('resize', syncCompact, { passive: true });
    syncCompact();
  }

  // ===================================
  // Mobile Navigation
  // ===================================
  function initMobileNav() {
    const toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
    const closeBtn = document.querySelector('[data-mobile-menu-close]');
    const mobileNav = document.querySelector('[data-mobile-nav]');
    
    if (!toggleBtn || !mobileNav) return;

    toggleBtn.addEventListener('click', () => {
      mobileNav.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        mobileNav.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Close on link click
    const navLinks = mobileNav.querySelectorAll('a');
    navLinks.forEach(link => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
    
    // Mobile submenu toggles
    document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(toggle => {
      toggle.addEventListener('click', function() {
        const submenuId = this.dataset.mobileSubmenuToggle;
        const submenu = document.querySelector(`[data-mobile-submenu="${submenuId}"]`);
        
        if (submenu) {
          const isOpen = submenu.style.display !== 'none';
          submenu.style.display = isOpen ? 'none' : 'block';
          this.classList.toggle('active', !isOpen);
        }
      });
    });
  }

  // ===================================
  // Hero Slider
  // ===================================
  function initHeroSlider() {
    const slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;

    const slides = slider.querySelector('[data-hero-slides]');
    const dots = slider.querySelectorAll('[data-hero-dot]');
    const prevBtn = slider.querySelector('[data-hero-prev]');
    const nextBtn = slider.querySelector('[data-hero-next]');
    
    if (!slides) return;
    
    const slideElements = slides.children;
    let currentSlide = 0;
    let autoplayInterval;
    const slideCount = slideElements.length;

    function goToSlide(index) {
      currentSlide = index;
      if (currentSlide >= slideCount) currentSlide = 0;
      if (currentSlide < 0) currentSlide = slideCount - 1;
      
      slides.style.transform = `translateX(-${currentSlide * 100}%)`;
      
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentSlide);
      });
    }

    function startAutoplay() {
      autoplayInterval = setInterval(() => goToSlide(currentSlide + 1), 5000);
    }

    function stopAutoplay() {
      clearInterval(autoplayInterval);
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        stopAutoplay();
        goToSlide(parseInt(dot.dataset.heroDot));
        startAutoplay();
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        stopAutoplay();
        goToSlide(currentSlide - 1);
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        stopAutoplay();
        goToSlide(currentSlide + 1);
        startAutoplay();
      });
    }

    if (slideCount > 1) {
      startAutoplay();
    }
  }

  // ===================================
  // Products Carousel
  // ===================================
  function initProductsCarousel() {
    const carousels = document.querySelectorAll('[data-products-carousel]');
    
    carousels.forEach(carousel => {
      const track = carousel.querySelector('[data-carousel-track]');
      const container = carousel.closest('.best-sellers-container, .testimonials-container');
      if (!container) return;
      
      const prevBtn = container.querySelector('[data-carousel-prev]');
      const nextBtn = container.querySelector('[data-carousel-next]');
      
      if (!track) return;
      
      let position = 0;
      const items = track.children;
      const itemWidth = items[0]?.offsetWidth + 24 || 300;
      const visibleItems = Math.floor(carousel.offsetWidth / itemWidth);
      const maxPosition = Math.max(0, items.length - visibleItems);

      function updatePosition() {
        track.style.transform = `translateX(-${position * itemWidth}px)`;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          position = Math.max(0, position - 1);
          updatePosition();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          position = Math.min(maxPosition, position + 1);
          updatePosition();
        });
      }
    });
  }

  // ===================================
  // Product Form Handling
  // ===================================
  function initProductForm() {
    const form = document.querySelector('[data-product-form]');
    if (!form) return;

    // Quantity controls
    const quantityInput = form.querySelector('[data-quantity-input], #Quantity');
    const minusBtn = form.querySelector('[data-quantity-minus]');
    const plusBtn = form.querySelector('[data-quantity-plus]');

    if (minusBtn && quantityInput) {
      minusBtn.addEventListener('click', () => {
        const current = parseInt(quantityInput.value) || 1;
        if (current > 1) quantityInput.value = current - 1;
      });
    }

    if (plusBtn && quantityInput) {
      plusBtn.addEventListener('click', () => {
        const current = parseInt(quantityInput.value) || 1;
        quantityInput.value = current + 1;
      });
    }

    // Variant selection + featured image swap
    const productJsonEl = document.getElementById('ProductJson');
    const productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
    const mainImage = document.getElementById('ProductMainImage');
    const thumbnails = document.querySelectorAll('.product-thumbnail');

    function updateVariantImage(variant) {
      if (!variant || !variant.featured_image || !mainImage) return;

      const fi = variant.featured_image;
      const src = fi.src || '';
      if (!src) return;

      mainImage.src = src.includes('width=')
        ? src.replace(/width=\d+/, 'width=1000')
        : src + (src.includes('?') ? '&' : '?') + 'width=1000';
      if (fi.alt) mainImage.alt = fi.alt;
      if (fi.src) {
        mainImage.dataset.zoomUrl = fi.src.replace(/width=\d+/, 'width=2000');
      }

      const mediaId = String(fi.id);
      let thumbIndex = -1;
      thumbnails.forEach((thumb, i) => {
        if (thumb.dataset.mediaId === mediaId) thumbIndex = i;
      });
      if (thumbIndex >= 0) {
        thumbnails.forEach(t => t.classList.remove('active'));
        thumbnails[thumbIndex].classList.add('active');
      }
    }

    function getSelectedOptions() {
      const groups = form.querySelectorAll('.product-variants');
      return Array.from(groups).map(group => {
        const selected = group.querySelector('.variant-option.selected');
        return selected ? selected.dataset.optionValue : null;
      });
    }

    const variantButtons = form.querySelectorAll('.variant-option');
    variantButtons.forEach(button => {
      button.addEventListener('click', () => {
        const siblings = button.parentElement.querySelectorAll('.variant-option');
        siblings.forEach(s => s.classList.remove('selected'));
        button.classList.add('selected');

        if (!productData) return;
        const selectedOptions = getSelectedOptions();
        const variant = productData.variants.find(v =>
          v.options.every((opt, i) => opt === selectedOptions[i])
        );
        if (variant) {
          const variantInput = form.querySelector('#ProductVariantId, [name="id"]');
          if (variantInput) variantInput.value = variant.id;
          updateVariantImage(variant);
        }
      });
    });

    // Add to cart
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const submitBtn = form.querySelector('.add-to-cart-btn, #AddToCart');
      const submitText = submitBtn.querySelector('#AddToCartText') || submitBtn;
      const originalText = submitText.innerHTML;
      
      submitBtn.disabled = true;
      submitText.innerHTML = 'Adding...';

      const formData = new FormData(form);
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        const data = await response.json();

        if (response.ok) {
          submitText.innerHTML = '✓ Added!';
          updateCartCount();
          
          setTimeout(() => {
            submitText.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 2000);
        } else {
          throw new Error(data.description || 'Error adding to cart');
        }
      } catch (error) {
        console.error('Add to cart error:', error);
        submitText.innerHTML = 'Error - Try Again';
        submitBtn.disabled = false;
        
        setTimeout(() => {
          submitText.innerHTML = originalText;
        }, 2000);
      }
    });

    // Buy Now button
    const buyNowBtn = form.querySelector('[data-buy-now], #BuyNow');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', async () => {
        const formData = new FormData(form);
        
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          window.location.href = '/checkout';
        } catch (error) {
          console.error('Buy now error:', error);
        }
      });
    }
  }

  // ===================================
  // Product Gallery
  // ===================================
  function initProductGallery() {
    const mainImage = document.querySelector('[data-product-image], #ProductMainImage');
    const thumbnails = document.querySelectorAll('[data-thumbnail], .product-thumbnail');
    const prevBtn = document.querySelector('[data-gallery-prev]');
    const nextBtn = document.querySelector('[data-gallery-next]');
    
    if (!mainImage || thumbnails.length === 0) return;

    let currentIndex = 0;

    function updateImage(index) {
      currentIndex = index;
      if (currentIndex >= thumbnails.length) currentIndex = 0;
      if (currentIndex < 0) currentIndex = thumbnails.length - 1;

      const thumbnail = thumbnails[currentIndex];
      const imageUrl = thumbnail.dataset.imageUrl;
      
      if (imageUrl) {
        mainImage.src = imageUrl;
      }
      
      thumbnails.forEach((t, i) => {
        t.classList.toggle('active', i === currentIndex);
      });
    }

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => updateImage(index));
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => updateImage(currentIndex - 1));
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => updateImage(currentIndex + 1));
    }
  }

  // ===================================
  // Product page accordions (Description, Specifications, Reviews)
  // ===================================
  function initProductAccordion() {
    document.querySelectorAll('[data-accordion]').forEach(function(item) {
      if (item.dataset.accordionBound === 'true') return;
      var btn = item.querySelector('.product-accordion-btn');
      if (!btn) return;
      item.dataset.accordionBound = 'true';
      btn.addEventListener('click', function() {
        var willOpen = !item.classList.contains('open');
        item.classList.toggle('open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  }

  // ===================================
  // Product Tabs
  // ===================================
  function initProductTabs() {
    const tabBtns = document.querySelectorAll('[data-tab], .product-tab-btn');
    const tabContents = document.querySelectorAll('.tab-content, [data-tab-content]');

    tabBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const tabId = btn.dataset.tab;
        
        tabBtns.forEach(b => b.classList.remove('active'));
        tabContents.forEach(c => c.classList.remove('active'));
        
        btn.classList.add('active');
        
        const targetContent = document.getElementById(tabId) || document.querySelector(`[data-tab-content="${tabId}"]`);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  }

  // ===================================
  // Cart Count Update
  // ===================================
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const countBadges = document.querySelectorAll('.cart-count-badge');
      countBadges.forEach(badge => {
        if (cart.item_count > 0) {
          badge.textContent = cart.item_count;
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }
  
  // Make it globally available
  window.updateCartCount = updateCartCount;

  // ===================================
  // Search Toggle
  // ===================================
  function initSearch() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchDropdown = document.querySelector('[data-search-dropdown]');
    const searchInput = searchDropdown?.querySelector('input');

    if (!searchToggle || !searchDropdown) return;

    searchToggle.addEventListener('click', (e) => {
      e.stopPropagation();
      searchDropdown.classList.toggle('active');
      if (searchDropdown.classList.contains('active') && searchInput) {
        searchInput.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!searchDropdown.contains(e.target) && !searchToggle.contains(e.target)) {
        searchDropdown.classList.remove('active');
      }
    });
  }

  // ===================================
  // Testimonials Slider
  // ===================================
  function initTestimonialsSlider() {
    const slider = document.querySelector('[data-testimonials-slider]');
    if (!slider) return;

    const track = slider.querySelector('[data-testimonials-track]');
    const dots = document.querySelectorAll('[data-testimonial-dot]');
    
    if (!track || dots.length === 0) return;

    let currentPage = 0;
    const cards = track.children;
    const cardsPerPage = window.innerWidth > 968 ? 3 : window.innerWidth > 600 ? 2 : 1;
    const totalPages = Math.ceil(cards.length / cardsPerPage);

    function goToPage(index) {
      currentPage = index;
      const cardWidth = cards[0]?.offsetWidth + 32 || 300;
      track.style.transform = `translateX(-${currentPage * cardsPerPage * cardWidth}px)`;
      
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentPage);
      });
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goToPage(index));
    });
  }
  
  // ===================================
  // FAQ Accordion
  // ===================================
  function initFaqAccordion() {
    document.querySelectorAll('[data-faq-toggle]').forEach(toggle => {
      toggle.addEventListener('click', function() {
        const content = this.nextElementSibling;
        const icon = this.querySelector('[data-faq-icon]');
        const isOpen = content.style.maxHeight;
        
        // Close all other FAQs
        document.querySelectorAll('[data-faq-content]').forEach(c => {
          c.style.maxHeight = null;
        });
        document.querySelectorAll('[data-faq-icon]').forEach(i => {
          i.style.transform = '';
        });
        
        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
          if (icon) icon.style.transform = 'rotate(45deg)';
        }
      });
    });
  }

  // ===================================
  // Smooth Scroll
  // ===================================
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        if (href === '#') return;
        
        const target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // ===================================
  // Lazy Loading Images
  // ===================================
  function initLazyLoading() {
    if ('loading' in HTMLImageElement.prototype) {
      const images = document.querySelectorAll('img[loading="lazy"]');
      images.forEach(img => {
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
      });
    }
  }
  
  // ===================================
  // Animation on Scroll
  // ===================================
  function initScrollAnimations() {
    if ('IntersectionObserver' in window) {
      const animateObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            animateObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1 });
      
      document.querySelectorAll('[data-animate]').forEach(el => {
        animateObserver.observe(el);
      });
    }
  }

  // ===================================
  // Initialize
  // ===================================
  function init() {
    agentLog({sessionId:'f20f57',runId:'pre-fix',hypothesisId:'H5',location:'assets/theme.js:524',message:'Global theme init executed',data:{pathname:window.location.pathname,href:window.location.href,readyState:document.readyState},timestamp:Date.now()});
    initHeader();
    initMobileNav();
    initHeroSlider();
    initProductsCarousel();
    initProductForm();
    initProductGallery();
    initProductAccordion();
    initProductTabs();
    initSearch();
    initTestimonialsSlider();
    initFaqAccordion();
    initSmoothScroll();
    initLazyLoading();
    initScrollAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();

// ===================================
// Shopify Money Format Helper
// ===================================
if (!window.Shopify) window.Shopify = {};

Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  const value = cents / 100;
  const formatString = format || window.Shopify.money_format || '${{amount}}';

  return formatString
    .replace('{{amount}}', value.toFixed(2))
    .replace('{{amount_no_decimals}}', Math.round(value));
};
